// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Package/components/ProductPrice/index.css
// module id = 2289
// module chunks = 0